var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPixisLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37692 8.80753L8.98106 4.2913C9.32722 3.31591 9.93795 2.47708 10.7328 1.88536C11.5276 1.29363 12.4692 0.976782 13.4334 0.976563L26.8209 0.976562C27.1971 0.97841 27.5672 1.07949 27.8992 1.27107C28.2313 1.46265 28.5153 1.73897 28.7268 2.07616C28.9382 2.41335 29.0707 2.80126 29.1129 3.20638C29.155 3.61151 29.1055 4.02166 28.9686 4.4014L27.3645 8.80753H7.37692ZM6.8832 10.2003L4.11338 18.0061H20.2439C21.4121 17.8973 22.5292 17.4379 23.4699 16.6794C24.4106 15.9209 25.1377 14.8934 25.5696 13.712L26.8512 10.2003H6.8832ZM3.61967 19.3969L0.885498 27.1004H6.75665C7.43557 27.1003 8.09858 26.8775 8.65848 26.4614C9.21839 26.0452 9.64898 25.4552 9.89363 24.7689L11.8097 19.3969H3.61967Z",
    fill: "url(#paint0_linear_9_151552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_151552",
    x1: 15.0091,
    y1: -0.0279026,
    x2: 15.0091,
    y2: 28.0933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BB3F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F64FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixisLogo);
export default __webpack_public_path__ + "static/media/pixisLogo.50ed4aaa73e594dce2ec12cb61c754da.svg";
export { ForwardRef as ReactComponent };